import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag, Menu, X, User, LogOut } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import { navigationLinks } from '../data/mock';

const Header = () => {
  const { setIsCartOpen, itemCount } = useCart();
  const { isAuthenticated, isAdmin, user, logoutUser } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo">
          <img 
            src="https://customer-assets.emergentagent.com/job_puter-klub/artifacts/wdaauptq_Logo_V%20%281%29.png" 
            alt="Ganetov Premium Puter" 
            className="logo-image"
          />
        </Link>

        <nav className="nav-desktop">
          {navigationLinks.map((link) => (
            <a key={link.name} href={link.href} className="nav-link">
              {link.name}
            </a>
          ))}
        </nav>

        <div className="header-actions">
          {isAuthenticated ? (
            <div className="user-menu-container">
              <button 
                className="user-menu-btn"
                onClick={() => setShowUserMenu(!showUserMenu)}
              >
                <User size={20} />
                <span className="user-name">{user?.name?.split(' ')[0]}</span>
              </button>
              
              {showUserMenu && (
                <div className="user-dropdown">
                  {isAdmin && (
                    <Link to="/admin" className="dropdown-item" onClick={() => setShowUserMenu(false)}>
                      Admin Panel
                    </Link>
                  )}
                  <Link to="/profil" className="dropdown-item" onClick={() => setShowUserMenu(false)}>
                    Moj profil
                  </Link>
                  <button className="dropdown-item logout" onClick={() => { logoutUser(); setShowUserMenu(false); }}>
                    <LogOut size={16} />
                    Odjavi se
                  </button>
                </div>
              )}
            </div>
          ) : (
            <Link to="/prijava" className="login-btn">
              <User size={20} />
              <span>Prijava</span>
            </Link>
          )}

          <button
            className="cart-button"
            onClick={() => setIsCartOpen(true)}
            aria-label="Korpa"
          >
            <ShoppingBag size={22} />
            {itemCount > 0 && <span className="cart-badge">{itemCount}</span>}
          </button>

          <button
            className="mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Menu"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
        {navigationLinks.map((link) => (
          <a
            key={link.name}
            href={link.href}
            className="mobile-nav-link"
            onClick={() => setMobileMenuOpen(false)}
          >
            {link.name}
          </a>
        ))}
        {isAuthenticated ? (
          <>
            {isAdmin && (
              <Link to="/admin" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>
                Admin Panel
              </Link>
            )}
            <Link to="/profil" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>
              Moj profil
            </Link>
          </>
        ) : (
          <Link to="/prijava" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>
            Prijava / Registracija
          </Link>
        )}
      </div>
    </header>
  );
};

export default Header;
